document.addEventListener('DOMContentLoaded', function () {
  const toggleReadMore = () => {
    document.querySelectorAll('.read-more-toggle').forEach(toggle => {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();

        // Collapse all other open blocks
        document.querySelectorAll('.read-more-container').forEach(container => {
          const moreText = container.querySelector('.more-text');
          const otherToggle = container.querySelector('.read-more-toggle');

          if (
            container !== this.closest('.read-more-container') &&
            moreText.classList.contains('show')
          ) {
            moreText.classList.remove('show');
            otherToggle.classList.remove('expanded');
          }
        });

        // Toggle current block
        const currentContainer = this.closest('.read-more-container');
        const currentText = currentContainer.querySelector('.more-text');
        const isOpen = currentText.classList.contains('show');

        currentText.classList.toggle('show');
        this.classList.toggle('expanded', !isOpen);

        // Update text based on new state
        this.textContent = isOpen
          ? this.dataset.textMore
          : this.dataset.textLess;
      });
    });
  };

  toggleReadMore();
});
